import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading, ssoError } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#000000',
        color: '#ffffff'
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated()) {
    return <Login error={ssoError} />;
  }

  return children;
};

export default PrivateRoute;